function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 1.81028,
  y: 2.48509,
  width: 50.9815,
  height: 52.5418,
  rx: 25.4908,
  stroke: "white",
  strokeWidth: 3.45797
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.7115 32.7896C20.9914 32.4508 20.4919 31.7198 20.4919 30.8721C20.4919 29.7029 21.4405 28.7544 22.608 28.7544C22.9594 28.7544 23.2903 28.8411 23.5833 28.9923C24.7666 29.5722 26.0965 29.8967 27.5019 29.8967C28.9106 29.8967 30.242 29.5706 31.4284 28.9892C31.7183 28.8395 32.0476 28.7544 32.3959 28.7544C33.5634 28.7544 34.5119 29.7029 34.5119 30.8721C34.5119 31.7198 34.0109 32.454 33.2892 32.7912C32.492 33.1835 31.6474 33.4971 30.7682 33.7208L33.6595 36.9982C34.4331 37.8742 34.3496 39.2135 33.4736 39.9871C32.5975 40.7592 31.2582 40.6757 30.4846 39.7996L27.5004 36.4183L24.5161 39.7996C23.7425 40.6757 22.4032 40.7592 21.5271 39.9871C20.6511 39.2135 20.5676 37.8742 21.3412 36.9982L24.2325 33.7208C23.3533 33.4955 22.5103 33.1819 21.7115 32.7896Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.9891 22.0037C33.9891 18.427 31.0836 15.5215 27.5069 15.5215C23.9302 15.5215 21.0247 18.427 21.0247 22.0037C21.0247 25.5804 23.9302 28.4858 27.5069 28.4858C31.0836 28.4858 33.9891 25.5804 33.9891 22.0037ZM30.0544 22.003C30.0544 20.5991 28.9136 19.4584 27.5097 19.4584C26.1058 19.4584 24.9651 20.5991 24.9651 22.003C24.9651 23.4069 26.1058 24.5477 27.5097 24.5477C28.9136 24.5477 30.0544 23.4069 30.0544 22.003Z",
  fill: "white"
});

var SvgIcOk = function SvgIcOk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 57,
    viewBox: "0 0 55 57",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcOk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-ok.59d63e83.svg";
export { ForwardRef as ReactComponent };